module.exports = "/_next/static/images/8094ae19da2b5f6601722f09d62c03cf-sarlaft-lg.png";